import React, { Component, Fragment } from 'react';
import './App.css';
import Routes from "./Routes";
import Footer from "./containers/Footer";
import { Auth, API } from "aws-amplify";
import { Link, withRouter } from "react-router-dom";

class App extends Component {

  constructor(props){
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true
    }
  }

  async componentDidMount(){
    try{
      if(await Auth.currentSession()){
        this.userHasAuthenticated(true);
      }
    }catch(e){
       if(e !== 'No current user'){
         // alert(e.message);
       }
    }
    this.setState( { isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = async event => {
    event.preventDefault();
    this.logoutHandler();
  }

  logoutHandler = async () => {
    await Auth.signOut();
    this.userHasAuthenticated(false);
    this.props.history.push("/login");
  }

  updateCaseOfTheMonth = caseOfTheMonth => {
    this.state.caseOfTheMonth = caseOfTheMonth;
  }

  getCaseOfTheMonth = async () => {
    if(!this.state.caseOfTheMonth){

        var caseOfTheMonth = await API.get("retnetindia", "/com");

        this.updateCaseOfTheMonth(caseOfTheMonth);
    }

    return this.state.caseOfTheMonth;
  }


  render() {
    const childProps = {
       isAuthenticated: this.state.isAuthenticated,
       userHasAuthenticated: this.userHasAuthenticated,
       logoutHandler: this.logoutHandler,
       updateCaseOfTheMonth: this.updateCaseOfTheMonth,
       getCaseOfTheMonth: this.getCaseOfTheMonth
     };

    return (
      !this.state.isAuthenticating &&
      <div className="retnet-content">
          <div className="header">
              <nav className="navbar navbar-expand-lg navbar--bold navbar-light bg-default  navbar--bb-1px">
                  <div className="container navbar-container">

                      <a className="navbar-brand" href="/">
                          <img src="/images/logo_retnetindia.png" className="" alt="Retnet India" />
                          <p className="caption">Known is a drop; Unknown is an ocean</p>
                      </a>

                      <div className="d-inline-block">

                          <button className="navbar-toggler hamburger hamburger-js hamburger--spring" type="button" data-toggle="collapse" data-target="#navbar_main" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                              <span className="hamburger-box">
                                  <span className="hamburger-inner"></span>
                              </span>
                          </button>
                      </div>

                      <div className="collapse navbar-collapse align-items-center justify-content-end" id="navbar_main">

                          <div className="navbar-search-widget b-xs-bottom py-3 d-lg-none d-none">
                              <form className="" >
                                  <div className="input-group input-group-lg">
                                      <input type="text" className="form-control" placeholder="Search for..." />
                                      <span className="input-group-btn">
                                            <button className="btn btn-base-3" type="button">Go!</button>
                                      </span>
                                  </div>
                              </form>
                          </div>


                          <ul className="navbar-nav">
                              <li className="nav-item">
                                  <a href="/" className="nav-link">
                                      Home
                                  </a>
                              </li>

                              {
                                this.state.isAuthenticated
                                   ? <Fragment>
                                      <li className="nav-item">
                                         <a href="/blogs" className="nav-link">
                                            Blogs
                                         </a>
                                     </li>
                                     <li className="nav-item">
                                        <a href="/doctors" className="nav-link">
                                           Doctors Directory
                                        </a>
                                    </li>

                                     </Fragment>
                                   :  <span></span>
                              }
                            

                              <li className="nav-item">
                                  <a href="/aboutus" className="nav-link">
                                      About Us
                                  </a>
                              </li>

                              <li className="nav-item">
                                  <a href="/gallery" className="nav-link">
                                      Gallery
                                  </a>
                              </li>
                              <li className="nav-item">
                                  <a href="/contactus" className="nav-link">
                                      Contact
                                  </a>
                              </li>
                              {this.state.isAuthenticated
                                    ?    <Fragment>
                                              <li className="nav-item">
                                                  <a href="/blogs/new" className="btn btn-styled btn-sm btn-base-1 text-uppercase btn-circle retnet-btn">
                                                      New Blog
                                                  </a>
                                              </li>
                                              <li className="nav-item">
                                                  <a href="" onClick={this.handleLogout} className="btn btn-styled btn-sm btn-base-1 text-uppercase btn-circle retnet-btn">
                                                      Logout
                                                  </a>
                                              </li>

                                         </Fragment>

                                    :   <Fragment>
                                            <li className="nav-item">
                                                <a href="/" className="btn btn-styled btn-sm btn-base-1 text-uppercase btn-circle retnet-btn">
                                                    Login
                                                </a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/signup"  className="btn btn-styled btn-sm btn-base-1 text-uppercase btn-circle retnet-btn">
                                                    Signup
                                                </a>
                                            </li>

                                      </Fragment>

                              }

                          </ul>
                      </div>


                      <div className="pl-4 d-none d-lg-inline-block">


                      </div>
                  </div>
              </nav>
          </div>

          <Routes  childProps = { childProps } />

          <Footer />
      </div>
    );
  }


}
export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js